// hooks/useCalendarNavigation.ts
import { useCallback } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { useEventsStore } from 'store/useEventsStore'
import { DayjsInput } from 'utils/dayjs'
import { MonthProps } from '~types'

export const useCalendarNavigation = (setSelectedDate: (date: DayjsInput) => void) => {
  const { selectedMonth, activeMonthList } = useEventsStore()

  const handleNavigation = useCallback(
    (key: string) => {
      const monthFormat = 'MMM-YYYY'
      const currentIndex = activeMonthList.findIndex(m =>
        dayjs(m, monthFormat).isSame(dayjs(selectedMonth.value, 'MMMM-YYYY'), 'month')
      )

      if (currentIndex === -1) return

      if (key === 'next' && currentIndex < activeMonthList.length - 1) {
        setCurrentMonth(dayjs(activeMonthList[currentIndex + 1], monthFormat))
      } else if (key === 'previous' && currentIndex > 0) {
        setCurrentMonth(dayjs(activeMonthList[currentIndex - 1], monthFormat))
      } else if (key === 'today') {
        const today = dayjs().startOf('month')
        const todayIndex = activeMonthList.findIndex(m => dayjs(m, monthFormat).isSame(today, 'month'))
        if (todayIndex !== -1) {
          setCurrentMonth(dayjs(activeMonthList[todayIndex], monthFormat))
        }
      }
    },
    [activeMonthList, selectedMonth.value]
  )

  const setCurrentMonth = (month: Dayjs) => {
    setSelectedDate(dayjs(month, 'MMMM-YYYY').startOf('month').toDate())
  }

  const setSelectedMonth = (month: MonthProps) => {
    setSelectedDate(dayjs(month.value, 'MMMM-YYYY').startOf('month').toDate())
  }

  return {
    handleNavigation,
    setCurrentMonth,
    setSelectedMonth
  }
}
